<template>
  <div class="news-detail-page">
    <!-- 头部导航 - 使用公共组件 -->
    <Navbar />

    <!-- 文章头部 -->
    <section class="article-header-section">
      <div class="container">
        <div class="article-meta">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/news' }">新闻资讯</el-breadcrumb-item>
            <el-breadcrumb-item>{{ article.title }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        
        <div class="article-info">
          <h1 class="article-title">{{ article.title }}</h1>
          <div class="article-meta-info">
            <div class="meta-item">
              <i class="el-icon-time"></i>
              <span>{{ article.publishDate }}</span>
            </div>
            <div class="meta-item">
              <i class="el-icon-view"></i>
              <span>{{ article.views }} 阅读</span>
            </div>
            <div class="meta-item">
              <i class="el-icon-folder-opened"></i>
              <span>{{ article.category }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 文章内容 -->
    <section class="article-content-section">
      <div class="container">
        <div class="content-wrapper">
          <!-- 左侧：文章正文 -->
          <article class="article-main">
            <!-- 文章封面图 -->
            <div class="article-image" v-if="article.image">
              <img :src="article.image" :alt="article.title" />
            </div>

            <!-- 文章摘要 -->
            <div class="article-summary" v-if="article.summary">
              <p>{{ article.summary }}</p>
            </div>

            <!-- 文章内容 -->
            <div class="article-content" v-html="article.content"></div>

            <!-- 文章底部导航 -->
            <div class="article-footer">
              <div class="article-nav">
                <div class="nav-item prev" v-if="prevArticle" @click="goToArticle(prevArticle.id)">
                  <span class="nav-label">上一篇</span>
                  <span class="nav-title">{{ prevArticle.title }}</span>
                </div>
                <div class="nav-item next" v-if="nextArticle" @click="goToArticle(nextArticle.id)">
                  <span class="nav-label">下一篇</span>
                  <span class="nav-title">{{ nextArticle.title }}</span>
                </div>
              </div>
            </div>
          </article>

          <!-- 右侧：侧边栏 -->
          <aside class="article-sidebar">
            <!-- 相关推荐 -->
            <div class="sidebar-widget">
              <h3 class="widget-title">相关推荐</h3>
              <div class="related-articles">
                <div 
                  v-for="relatedArticle in relatedArticles" 
                  :key="relatedArticle.id"
                  class="related-item"
                  @click="goToArticle(relatedArticle.id)"
                >
                  <div class="related-image">
                    <img :src="relatedArticle.image" :alt="relatedArticle.title" />
                  </div>
                  <div class="related-content">
                    <h4 class="related-title">{{ relatedArticle.title }}</h4>
                    <p class="related-meta">
                      <span>{{ relatedArticle.publishDate }}</span>
                      <span>{{ relatedArticle.views }} 阅读</span>
                    </p>
                  </div>
                </div>
                <div v-if="relatedArticles.length === 0" class="related-empty">
                  暂无相关推荐
                </div>
              </div>
            </div>

            <!-- 返回列表 -->
            <div class="sidebar-widget">
              <el-button type="primary" @click="backToList" size="large" style="width: 100%">
                <i class="el-icon-back"></i>
                返回新闻列表
              </el-button>
            </div>
          </aside>
        </div>
      </div>
    </section>

    <!-- 底部区域 - 使用公共组件 -->
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'NewsDetail',
  components: {
    Navbar,
    Footer
  },
  data() {
    return {
      loading: false,
      article: {
        id: 1,
        title: '加载中...',
        summary: '',
        content: '',
        image: null,
        publishDate: '',
        views: 0,
        category: '',
        categoryId: null
      },
      relatedArticles: [],
      oldArticle: {
        id: 1,
        title: '新国标实施对工业检测的影响与应对措施',
        summary: '2025年最新国家标准正式生效，对企业安全检测提出更高要求。新规定明确了各类安全设备的检测周期和标准，有助于提升整体工业安全水平。',
        content: `
          <h2>新国标的主要变化</h2>
          <p>2025年1月1日起，新修订的《工业安全设备检测规范》正式实施，该标准对现有检测体系进行了全面升级，主要变化包括：</p>
          
          <h3>检测周期调整</h3>
          <p>根据新标准要求，部分关键设备的检测周期有所调整：</p>
          <ul>
            <li><strong>空气呼吸器</strong>：检测周期从12个月调整为10个月</li>
            <li><strong>气体报警仪</strong>：检测周期从6个月调整为4个月</li>
            <li><strong>压力容器</strong>：根据使用环境分为不同检测等级</li>
          </ul>

          <h3>技术要求提升</h3>
          <p>新标准对检测技术提出了更高要求：</p>
          <ol>
            <li>引入智能化检测设备，提高检测精度</li>
            <li>增加数据记录和追溯要求</li>
            <li>强化检测人员资质管理</li>
          </ol>

          <h2>对企业的影响</h2>
          <p>新国标的实施将对相关企业产生以下影响：</p>

          <h3>成本影响</h3>
          <p>由于检测周期的缩短和技术要求的提升，企业在安全检测方面的投入将有所增加。但从长远来看，这有助于降低安全风险和事故成本。</p>

          <h3>管理要求</h3>
          <p>企业需要建立更加完善的设备管理档案，确保检测记录的完整性和可追溯性。</p>

          <h2>慧安检测的应对措施</h2>
          <p>为了更好地服务客户，我们已采取以下措施：</p>

          <blockquote>
            <p>我们已完成所有检测设备的升级改造，检测能力完全符合新国标要求。同时，我们的技术团队也接受了专业培训，确保服务质量。</p>
          </blockquote>

          <h3>设备升级</h3>
          <p>公司投入500万元用于检测设备的更新换代，引进了多台先进的智能检测设备。</p>

          <h3>人员培训</h3>
          <p>所有检测人员均已完成新标准培训，并通过了相关考核。</p>

          <h3>服务优化</h3>
          <p>我们优化了服务流程，缩短了检测周期，提高了服务效率。</p>

          <h2>给客户的建议</h2>
          <p>建议广大客户：</p>
          <ul>
            <li>及时了解新标准要求，调整设备检测计划</li>
            <li>选择具备相应资质的检测机构</li>
            <li>建立完善的设备管理制度</li>
            <li>定期关注标准更新动态</li>
          </ul>

          <p>如有任何疑问，欢迎随时联系我们的技术服务团队。</p>
        `,
        image: require('@/assets/news1.jpg'),
        publishDate: '2025-09-20',
        views: 1245,
        category: '行业动态',
        author: '技术部'
      },
      prevArticle: null,
      nextArticle: null
    }
  },
  methods: {
    // 获取文章数据
    async fetchArticle(id) {
      try {
        this.loading = true
        const response = await this.$axios.get(`/api/news/${id}`)
        
        if (response.data.code === 200) {
          const news = response.data.data
          this.article = {
            id: news.id,
            title: news.title,
            summary: news.summary || '',
            content: news.content || '',
            image: news.image_url || null,
            publishDate: this.formatDate(news.created_at),
            views: news.views || 0,
            category: news.category_name || '',
            categoryId: news.category_id
          }
          this.updatePageTitle()
          
          // 获取相关推荐
          this.fetchRelatedArticles()
        }
      } catch (error) {
        console.error('获取新闻详情失败:', error)
        this.$message.error('获取新闻详情失败')
      } finally {
        this.loading = false
      }
    },
    
    // 获取相关推荐（同分类的其他新闻）
    async fetchRelatedArticles() {
      try {
        if (!this.article.categoryId) return
        
        const response = await this.$axios.get('/api/news', {
          params: {
            category_id: this.article.categoryId,
            status: 1,
            page: 1,
            pageSize: 5
          }
        })
        
        if (response.data.code === 200) {
          const result = response.data.data
          // 过滤掉当前文章，只取其他文章
          this.relatedArticles = result.list
            .filter(news => news.id !== this.article.id)
            .slice(0, 3)
            .map(news => ({
              id: news.id,
              title: news.title,
              image: news.image_url || require('@/assets/news1.jpg'),
              publishDate: this.formatDate(news.created_at),
              views: news.views || 0
            }))
        }
      } catch (error) {
        console.error('获取相关推荐失败:', error)
      }
    },
    
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    
    // 获取文章数据（旧方法，保留作为备份）
    fetchArticleOld(id) {
      // 模拟根据ID获取不同文章
      const articles = {
        1: this.oldArticle,
        2: {
          id: 2,
          title: '慧安检测荣获2025年度行业创新奖',
          summary: '凭借先进的检测技术和优质服务，公司荣获2025年度行业创新奖。',
          content: '<h2>获奖背景</h2><p>在激烈的行业竞争中，慧安检测凭借...</p>',
          image: require('@/assets/news2.jpg'),
          publishDate: '2025-09-15',
          views: 2138,
          likes: 45,
          category: '公司新闻',
          author: '行政部'
        },
        9: {
          id: 9,
          title: '陕西省检验检测机构资质认定自我声明公开承诺书',
          summary: '本机构就提交的资质认定申报事项自我声明公开承诺，确保申请材料真实、合法、有效，符合相关法律法规要求，自觉接受社会监督。',
          content: `
            <div class="certificate-image-container">
              <img src="${require('@/assets/chengnuoshu.png')}" alt="陕西省检验检测机构资质认定自我声明公开承诺书" style="width: 100%; max-width: 900px; margin: 0 auto; display: block; border-radius: 8px; box-shadow: 0 4px 16px rgba(0,0,0,0.1);" />
            </div>
          `,
          image: null,
          publishDate: '2025-10-15',
          views: 156,
          likes: 8,
          category: '公司新闻',
          author: '综合管理部',
          hideCover: true
        }
      }
      
      this.article = articles[id] || this.article
      this.updatePageTitle()
    },
    
    // 跳转到文章
    goToArticle(id) {
      this.$router.push(`/news/${id}`)
    },
    
    // 返回列表
    backToList() {
      this.$router.push('/news')
    },
    
    // 更新页面标题
    updatePageTitle() {
      document.title = `${this.article.title} - 慧安检测`
    }
  },
  
  mounted() {
    const articleId = this.$route.params.id
    this.fetchArticle(articleId)
  },
  
  watch: {
    '$route'(to, from) {
      if (to.params.id !== from.params.id) {
        this.fetchArticle(to.params.id)
      }
    }
  }
}
</script>

<style scoped>
.news-detail-page {
  min-height: 100vh;
  background: #ffffff;
}

/* 文章头部 */
.article-header-section {
  padding: 120px 0 40px;
  background: #f7f8fa;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.article-meta {
  margin-bottom: 32px;
}

.article-info {
  max-width: 800px;
}

.article-title {
  font-size: 36px;
  font-weight: 700;
  color: #333333;
  line-height: 1.4;
  margin: 0 0 24px 0;
}

.article-meta-info {
  display: flex;
  gap: 24px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #666666;
}

.meta-item i {
  font-size: 16px;
  color: #1e3a8a;
}

/* 文章内容区域 */
.article-content-section {
  padding: 40px 0 80px;
  background: #ffffff;
}

.content-wrapper {
  display: grid;
  grid-template-columns: 1fr 320px;
  gap: 60px;
}

/* 文章正文 */
.article-main {
  background: white;
}

.article-image {
  margin-bottom: 32px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.article-image img {
  width: 100%;
  height: 400px;
  object-fit: cover;
}

.article-summary {
  background: #f8f9fa;
  padding: 20px;
  border-left: 4px solid #1e3a8a;
  margin-bottom: 32px;
  border-radius: 0 8px 8px 0;
}

.article-summary p {
  font-size: 16px;
  line-height: 1.7;
  color: #666666;
  margin: 0;
  font-style: italic;
}

.article-content {
  font-size: 16px;
  line-height: 1.8;
  color: #333333;
}

.article-content h2 {
  font-size: 24px;
  font-weight: 600;
  color: #333333;
  margin: 40px 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #1e3a8a;
}

.article-content h3 {
  font-size: 20px;
  font-weight: 600;
  color: #333333;
  margin: 32px 0 16px 0;
}

.article-content p {
  margin: 16px 0;
  text-align: justify;
}

.article-content ul,
.article-content ol {
  margin: 16px 0;
  padding-left: 32px;
}

.article-content li {
  margin: 8px 0;
}

.article-content blockquote {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
  border-left: 4px solid #1e3a8a;
  padding: 16px 20px;
  margin: 24px 0;
  border-radius: 0 8px 8px 0;
}

.article-content blockquote p {
  margin: 0;
  color: #666666;
  font-style: italic;
}

/* 文章底部 */
.article-footer {
  margin-top: 48px;
  padding-top: 32px;
  border-top: 1px solid #e8e8e8;
}


.article-nav {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.nav-item {
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.nav-item:hover {
  background: #1e3a8a;
  color: white;
}

.nav-item.prev {
  text-align: left;
}

.nav-item.next {
  text-align: right;
}

.nav-label {
  font-size: 12px;
  color: #999999;
  display: block;
  margin-bottom: 4px;
}

.nav-item:hover .nav-label {
  color: rgba(255, 255, 255, 0.8);
}

.nav-title {
  font-size: 14px;
  font-weight: 500;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 侧边栏 */
.article-sidebar {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.sidebar-widget {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0f0f0;
}

.widget-title {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin: 0 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #f0f0f0;
  position: relative;
}

.widget-title::before {
  content: '';
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 40px;
  height: 2px;
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
}

/* 相关推荐 */
.related-articles {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.related-item {
  display: flex;
  gap: 12px;
  cursor: pointer;
  transition: all 0.3s;
  padding: 8px;
  border-radius: 8px;
}

.related-item:hover {
  background: #f8f9fa;
}

.related-image {
  width: 80px;
  height: 60px;
  border-radius: 6px;
  overflow: hidden;
  background: #f5f5f5;
  flex-shrink: 0;
}

.related-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.related-content {
  flex: 1;
  min-width: 0;
}

.related-title {
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  margin: 0 0 6px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.related-meta {
  font-size: 12px;
  color: #999999;
  margin: 0;
  display: flex;
  gap: 12px;
}

.related-empty {
  text-align: center;
  padding: 40px 20px;
  color: #999999;
  font-size: 14px;
}

/* 响应式设计 */
@media (max-width: 992px) {
  .content-wrapper {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .article-title {
    font-size: 28px;
  }

  .article-meta-info {
    gap: 16px;
  }

  .article-nav {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

@media (max-width: 768px) {
  .article-header-section {
    padding: 100px 0 30px;
  }

  .article-title {
    font-size: 24px;
  }

  .article-content {
    font-size: 15px;
  }

  .article-content h2 {
    font-size: 20px;
  }

  .article-content h3 {
    font-size: 18px;
  }

  .article-image img {
    height: 250px;
  }

}
</style>
